import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { roleMap } from "../../Utills/enums";
// Import the new editUser action
import { deleteUser, editUser, fetchUserList, openGlobalPopup } from '../../redux/action'; // Import the addUser action
import CommonSearchBox from "../../component/SearchBox/CommomSearchBox";
import ConfirmBox from "../../component/Popup/ConfirmBox";
import EmptyScreen from '../../component/common/EmptyScreen';
import { useTranslation } from "react-i18next";

function  UserList() {
    const { t } = useTranslation();
    const users = useSelector((state) => state.admin?.users) || [];
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [deleteUser_id, setIsDeleteUser] = useState('');


    useEffect(() => {
        dispatch(fetchUserList());
    }, []);

    const filteredUsers = Object.values(users).filter((user) =>
        user.name.toLowerCase().includes(search.toLowerCase()) ||
        user.email.toLowerCase().includes(search.toLowerCase()) ||
        user.phone.toLowerCase().includes(search.toLowerCase()) ||
        (roleMap[user.roleId] || "").toLowerCase().includes(search.toLowerCase())
    );
    //roleMap[user.roleId]
    const handleDelete = (userId) => {
        setIsDeleteUser(userId);
        dispatch(openGlobalPopup("confirm-box"));
    };

    const handleEdit = (user) => {
        // In a real application, you'd usually open a modal or navigate to an edit form.
        // For demonstration, we'll use a prompt to simulate getting new data.
        dispatch(editUser(user));
        dispatch(openGlobalPopup("edit-user"));
    };

    return (
        <div className='table-container'>

             <h3 style={{ padding: "0px 0px 0px 10px" }}>{t("Existing Users")} ({Object.keys(filteredUsers).length})</h3>
                    <CommonSearchBox
                        placeholder="Search users by name,phone,email,role..."
                        search={search}
                        setSearch={setSearch}
                    />
                    
            {Object.keys(filteredUsers).length === 0 ? (
                <EmptyScreen message="No users found for the selected criteria." />
            ) : (
                <>
                   
                    <div className='table-wrapper'>
                        <table className='table' >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.values(filteredUsers).map((user) => (
                                    <tr key={user.userId}>
                                        <td>{user.name}</td>
                                        <td>{user.phone}</td>
                                        <td>{user.email}</td>
                                        <td>{roleMap[user.roleId]}</td>
                                        <td>

                                            <span
                                                className="edit-icon link-btn"
                                                title="Edit"
                                                aria-label="Edit"
                                                onClick={() => handleEdit(user)}
                                            >
                                                ✎
                                            </span>

                                            <span
                                                className="delete-icon link-btn danger"
                                                title="Delete"
                                                aria-label="Delete"
                                                onClick={() => handleDelete(user.userId)}
                                            >
                                                ✖
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            <ConfirmBox
                variant="delete"
                title="Are you sure you want to delete this user?"
                onConfirm={() => {
                    dispatch(deleteUser(deleteUser_id));
                }}
                onCancel={() => {
                    setIsDeleteUser('');
                }}
            />        </div>
    );
}
export default UserList;
